import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "currencySymbol",
  standalone: false,
})
export class CurrencySymbolPipe implements PipeTransform {
  private currencyMap: { [code: string]: string } = {
    USD: "$",
    EUR: "€",
    GBP: "£",
    RSD: "Din",
    BAM: "KM",
    CHF: "CHF",
    JPY: "¥",
    CAD: "CA$",
    AUD: "A$",
    INR: "₹",
  };

  transform(code: string): string {
    if (!code)
      return "";
    return this.currencyMap[code.toUpperCase()] || code;
  }
}
